<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/gardenList' }">
					<i class="el-icon-school"></i> 绘本开放幼儿园
				</el-breadcrumb-item>
				<el-breadcrumb-item>费用设置</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="300px">
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'幼儿园名称：'" prop="saaNAME">
							<el-input v-model="ruleForm.saaNAME"   disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="lable1+'：'" prop="iniVal1">
							<el-input v-model="ruleForm.iniVal1"  clearable    :placeholder="'请输入金额'" maxlength="7"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="lable2+'：'" prop="iniVal2">
							<el-input v-model="ruleForm.iniVal2"  clearable   :placeholder="'请输入金额'" maxlength="7"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="lable3+'：'" prop="iniVal3">
							<el-input v-model="ruleForm.iniVal3" clearable   :placeholder="'请输入金额'" maxlength="7"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="lable4+'：'" prop="iniVal4">
							<el-input v-model="ruleForm.iniVal4"  clearable  :placeholder="'请输入金额'" maxlength="7"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="lable5+'：'" prop="iniVal5">
							<el-input v-model="ruleForm.iniVal5"  clearable  :placeholder="'请输入金额'" maxlength="7"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'editHBFY',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			
			//验证字符串
			const checkVAL1 = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请填写金额'));
				 	} else {
						let reg = /^\d+(\.\d{1,2})?$/;;
						
						if (!reg.test(value)) {
							callback(new Error('请输入整数或者小数，且小数点后只保留两位'));
						}
				 	}
					callback()
			}
			const checkVAL2 = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请填写金额'));
				 	} else {
						let reg = /^\d+(\.\d{1,2})?$/;;
						
						if (!reg.test(value)) {
							callback(new Error('请输入整数或者小数，且小数点后只保留两位'));
						}
				 	}
					callback()
			}
			const checkVAL3 = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请填写金额'));
				 	} else {
						let reg = /^\d+(\.\d{1,2})?$/;;
						
						if (!reg.test(value)) {
							callback(new Error('请输入整数或者小数，且小数点后只保留两位'));
						}
				 	}
					callback()
			}
			const checkVAL4 = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请填写金额'));
				 	} else {
						let reg = /^\d+(\.\d{1,2})?$/;;
						
						if (!reg.test(value)) {
							callback(new Error('请输入整数或者小数，且小数点后只保留两位'));
						}
					
				 	}
						callback()
			}
			
			const checkVAL5 = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请填写金额'));
				 	} else {
						let reg = /^\d+(\.\d{1,2})?$/;;
						
						if (!reg.test(value)) {
							callback(new Error('请输入整数或者小数，且小数点后只保留两位'));
						}
				 	}
					callback()
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				sID:'',
				
				ruleForm: {
					iniVal1:'0.00',
					iniVal2:'0.00',
					iniVal3:'0.00',
					iniVal4:'0.00',
					iniVal5:'0.00',
					saaNAME:'',
					
				},
				lable1:'',
				lable2:'',
				lable3:'',
				lable4:'',
				lable5:'',
				
				inikey2:'',
				page:1,
				
				rules: {
					iniVal1:[{
						required: true,
						trigger: ['blur', 'change'],
						validator: checkVAL1
					}],
					iniVal2:[{
						required: true,
						trigger: ['blur', 'change'],
						validator: checkVAL2
					}],
					iniVal3:[{
						required: true,
						trigger: ['blur', 'change'],
						validator: checkVAL3
					}],
					iniVal4:[{
						required: true,
						trigger: ['blur', 'change'],
						validator: checkVAL4
					}],
					iniVal5:[{
						required: true,
						trigger: ['blur', 'change'],
						validator: checkVAL5
					}]
	
				}
			};
		},
		created() {
			this.sID = this.$route.query.SAAMSID;
			// this.page=this.$route.query.page;
			this.ruleForm.saaNAME = this.$route.query.name;
			this.getSMA_INI();
		},
		methods:{
			getSMA_INI() {
				var postUrl = 'WCF/WEB/svcSMA.svc/Get_SMA_BYID';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: this.web_sphon, //web侧 登录ID  tihs.web_suuid
							sID:this.sID,
							
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let data = response.data.KKDT;
							this.lable1=data[0].INIDISP;
							this.lable2=data[1].INIDISP;
							this.lable3=data[2].INIDISP;
							this.lable4=data[3].INIDISP;
							this.lable5=data[4].INIDISP;
							
							this.ruleForm.iniVal1=data[0].SMAHBFY;
							this.ruleForm.iniVal2=data[1].SMAHBFY;
							this.ruleForm.iniVal3=data[2].SMAHBFY;
							this.ruleForm.iniVal4=data[3].SMAHBFY;
							this.ruleForm.iniVal5=data[4].SMAHBFY;
							
							
							this.inikey2=data[0].INIKEY2+","+data[1].INIKEY2+","+data[2].INIKEY2+","+data[3].INIKEY2+","+data[4].INIKEY2;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});
			},
			
			
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
						var postUrl = 'WCF/WEB/svcSMA.svc/UPD_SMA';
						let val=this.ruleForm.iniVal1+','+this.ruleForm.iniVal2+','+this.ruleForm.iniVal3+','+this.ruleForm.iniVal4+","+this.ruleForm.iniVal5;
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: this.web_sphon, //web侧 登录ID  tihs.web_suuid
									sID: this.sID,
									sVAL:val,
									sKEY:this.inikey2
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
			
								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '更新失败', //新增失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('更新成功'); // 新增成功
										this.$router.push('/bookSAA') // 跳转路由
										
										// this.$router.push('/bookSAA?page='+this.page) 
										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editHBFY") {
												indexs = i;
												break;
											}
										}
										
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '提交失败', //表单验证失败
							type: 'error'
						});
					}
				});
			},
			
			goBack() {
				this.$router.go(-1);
				// this.$router.push('/bookSAA?page='+this.page) 
				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editHBFY") {
						indexs = i;
						break;
					}
				}
			
				this.closeTags(indexs);
			},
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			
		}
	}
</script>

<style>
</style>
